import useLoaderData from "./useLoaderData"

const EVENTS_PERMISSIONS = [
  'EVENTS_TRAINER',
  'EVENTS_EDIT',
  'EVENTS_TEMPLATE_EDIT',
];

const SHIPPING_PERMISSIONS = [
  'SHIPMENT_TRACKING_READ',
  'SHIPMENT_TRACKING_EDIT',
  'SHIPMENT_TRACKING_PUBLISH',
];

const ASSESSMENT_PERMISSIONS = [
  'ASSESSMENT_BUILDER_READ',
  'ASSESSMENT_BUILDER_EDIT',
  'ASSESSMENT_REPORTS_READ',
];

const QUEST_CODES_PERMISSIONS = [
  'QUEST_CODES_READ',
  'QUEST_CODES_EDIT',
];

const QUEST_PERMISSIONS = [
  'QUEST_USER',
  'QUEST_ADMIN',
];

const SLED_PERMISSIONS = [
  'SLED_USER',
  'SLED_ADMIN',
];

const TEACHER_PERMISSIONS = [
  'HUB_ADMIN',
  'HUB_USER',
  // district-level hub roles; a higher hub permission implies the lower ones
  'HUB_USER_SITE_LEADER',
  'HUB_USER_ADMIN',
];

const JOBS_PERMISSIONS = [
  'JOBS_READ',
  'JOBS_EDIT',
];

const CURRICULUM_MANAGER_PERMISSIONS = [
  'HUB_ADMIN',
];

const ASSET_MANAGER_PERMISSIONS = [
  'HUB_ADMIN',
];

const IMPLEMENTATION_CALENDAR_PERMISSIONS = [
  'HUB_ADMIN',
];

// Any of these marks the user as an internal ProSolve user. Note HUB_ADMIN is
// internal even though it also grants the (public) Teacher Portal.
const INTERNAL_PERMISSIONS = [
  ...EVENTS_PERMISSIONS,
  ...SHIPPING_PERMISSIONS,
  ...ASSESSMENT_PERMISSIONS,
  ...QUEST_CODES_PERMISSIONS,
  ...JOBS_PERMISSIONS,
  'HUB_ADMIN',
];

export default function useMe () {
  const { userId, permissions = '', source, isVerified } = useLoaderData()

  return { 
    userId,
    permissions,
    source,
    isVerified,
    eventsAccess: EVENTS_PERMISSIONS.some((perm) => permissions.includes(perm)),
    shippingAccess: SHIPPING_PERMISSIONS.some((perm) => permissions.includes(perm)),
    assessmentAccess: ASSESSMENT_PERMISSIONS.some((perm) => permissions.includes(perm)),
    questCodesAccess: QUEST_CODES_PERMISSIONS.some((perm) => permissions.includes(perm)),
    questAccess: QUEST_PERMISSIONS.some((perm) => permissions.includes(perm)),
    sledAccess: SLED_PERMISSIONS.some((perm) => permissions.includes(perm)),
    teacherAccess: TEACHER_PERMISSIONS.some((perm) => permissions.includes(perm)),
    jobsAccess: JOBS_PERMISSIONS.some((perm) => permissions.includes(perm)),
    curriculumManagerAccess: CURRICULUM_MANAGER_PERMISSIONS.some((perm) => permissions.includes(perm)),
    assetManagerAccess: ASSET_MANAGER_PERMISSIONS.some((perm) => permissions.includes(perm)),
    implementationCalendarAccess: IMPLEMENTATION_CALENDAR_PERMISSIONS.some((perm) => permissions.includes(perm)),
    isInternal: INTERNAL_PERMISSIONS.some((perm) => permissions.includes(perm)),
  }
}